import '@/sections/footer';
import '@/components/form/file';
import '@/components/buffer';
import {
    initCadastral,
    initCallbackPopup,
    initDetails,
    initFileUploader,
    initFirstScreen,
    initForm,
    initHeader,
    initPopup,
    initQuestions,
    initServices,
    initSliderSection,
    initTabs,
    initTenders,
    initTogglers,
    initVacancies,
    initVideo,
    lazyLoadElements
} from './common';
// @ts-ignore
import device from 'current-device';
import type {IDynamicImport} from '../../../stash/common/scripts/types/utils';
import type {IObserver} from '@/common/scripts/types/observer';
import Observer from './observer';
import searchPanelInit from '@/components/search-panel';
import {throttle} from 'throttle-debounce';
import {Utils} from '@/common/scripts/utils';

const observer: IObserver = new Observer();

// Определяем устройство
// eslint-disable-next-line
console.log('device.mobile() === %s', device.mobile());

// Поведение шапки
const headerWrap = document.querySelector('.j-header') as HTMLElement;

if (headerWrap) {
    initHeader(headerWrap);
}

/* Ленивая загрузка */
/* подключать после инициализации слайдеров */
const lazyElements = [...document.querySelectorAll('[loading=lazy]')];

if (lazyElements.length) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            lazyLoadElements(lazyElements);
        });
    } else {
        lazyLoadElements(lazyElements);
    }
}

// Формы
const formWrappers = [...document.querySelectorAll('.j-form')];

formWrappers.forEach((wrapper: Element) => {
    initForm(wrapper as HTMLElement);
});

// Попапы
const popupSelectors = [...document.querySelectorAll('.j-popup')] as HTMLElement[];

if (popupSelectors.length) {
    initPopup(popupSelectors, {removeDelay: 300});

    observer.subscribe('popup:open', (popup: any) => {
        if (popup?.data?.isWithMap) {
            const map = document.querySelector('.j-projects-map') as HTMLElement;

            if (map) {
                import(/* webpackChunkName: "location-section" */ '@/sections/projects-map')
                    .then(({default: initLocation}: IDynamicImport) => {
                        initLocation(map);
                    });
            }
        }
    });
}

// Отдельный селектор для попапов обратных звонков
const popupFacadeLinks = [...document.querySelectorAll('.j-popup-callback:not([data-init])')] as HTMLElement[];

if (popupFacadeLinks.length) {
    initCallbackPopup(popupFacadeLinks);

    popupFacadeLinks.forEach((button: HTMLElement) => {
        button.dataset['init'] = 'true';
    });
}

// Первый экран
const firstScreen = document.querySelector('.j-first-screen') as HTMLElement;

if (firstScreen) {
    initFirstScreen(firstScreen);
}

// Слайдер
const sliderSections = [...document.querySelectorAll('.j-slider-section')] as HTMLElement[];

sliderSections.forEach((wrapper: HTMLElement) => {
    initSliderSection(wrapper);
});

// Табы
const tabs = [...document.querySelectorAll('.j-tabs-wrap')];

tabs.forEach((elem: Element) => {
    initTabs(elem as HTMLElement);
});

// Видео
const videos = [...document.querySelectorAll('.j-video')] as HTMLElement[];

videos.forEach((video: HTMLElement) => {
    initVideo(video);
});

// Подписка
const subscribeWrappers = [...document.querySelectorAll('.j-subscribe')] as HTMLElement[];

subscribeWrappers.forEach((wrapper: HTMLElement) => {
    import(/* webpackChunkName: "subscribe" */ '@/components/subscribe')
        .then(({default: initSubscribe}: IDynamicImport) => {
            initSubscribe(wrapper);
        });
});

// Переключение проектов
const projectsList = [...document.querySelectorAll('.j-projects-list')] as HTMLElement[];

projectsList.forEach((wrapper: HTMLElement) => {
    import(/* webpackChunkName: "projects-list" */ '@/sections/projects-list')
        .then(({default: initProjectsList}: IDynamicImport) => {
            initProjectsList(wrapper);
        });
});

// Мини параметрический
const miniParametric = document.querySelector('.j-mini-parametric') as HTMLElement;

if (miniParametric) {
    import(/* webpackChunkName: "mini-parametric" */ '@/components/mini-parametric')
        .then(({default: MiniParametric}: IDynamicImport) => {
            new MiniParametric().init(miniParametric);
        });
}

// Апартаменты
const apartmentLayouts = [...document.querySelectorAll('.j-apartment-layout')] as HTMLElement[];

apartmentLayouts.forEach((wrapper: HTMLElement) => {
    import(/* webpackChunkName: "apartment-layouts" */ '@/sections/apartment-layout')
        .then(({default: ApartmentLayout}: IDynamicImport) => {
            new ApartmentLayout().init(wrapper);
        });
});

// Слайдер в табах
const sliderTabs = [...document.querySelectorAll('.j-slider-tabs-wrapper')] as HTMLElement[];

sliderTabs.forEach((wrapper: HTMLElement) => {
    import(/* webpackChunkName: "slider-tabs" */ '@/sections/slider-tabs')
        .then(({default: SliderTabs}: IDynamicImport) => {
            new SliderTabs().init(wrapper);
        });
});

// Туглеры
const togglers = [...document.querySelectorAll('.j-toggle-wrapper')] as HTMLElement[];

togglers.forEach((elem: HTMLElement) => {
    initTogglers(elem);
});

// Новости
const newsList = document.querySelector('.j-news-list') as HTMLElement;

if (newsList) {
    import(/* webpackChunkName: "news-list" */ '@/components/news-list')
        .then(({default: NewsList}: IDynamicImport) => {
            new NewsList().init(newsList);
        });
}

// Поделиться
const share = document.querySelector('.j-share') as HTMLElement;

if (share) {
    import(/* webpackChunkName: "share" */ '@/components/share')
        .then(({default: Share}: IDynamicImport) => {
            new Share().init({target: share});
        });
}

// Фикс vh для ios
const appHeight = (): void => {
    const vh = window.innerHeight * 0.01;

    document.documentElement.style.setProperty('--vh', `${vh}px`);
};

appHeight();

const resizeEvents = ['resize', 'onorientationchange'];

resizeEvents.forEach((event: string) => {
    window.addEventListener(event, throttle(50, appHeight));
});

// Слайдеры похожих квартир
const similarSliders = [...document.querySelectorAll('.j-similar-flats')] as HTMLElement[];

similarSliders.forEach((slider: HTMLElement) => {
    import(/* webpackChunkName: "similar-slider" */ '@/sections/similar-flats')
        .then(({default: SimilarFlats}: IDynamicImport) => {
            new SimilarFlats().init(slider);
        });
});

// Сохраняем просмотренные квартиры
const flatCard = document.querySelector('.j-flat-card') as HTMLElement;

if (flatCard) {
    const cardCookieName = 'viewedFlatsIds';
    const currentCardId = flatCard.dataset['id'];

    if (currentCardId) {
        if (Utils.getCookie(cardCookieName)) {
            const currentIds = JSON.parse(Utils.getCookie(cardCookieName) || '[]');

            if (currentIds.includes(currentCardId)) {
                const index = currentIds.findIndex((item: string) => {
                    return item === currentCardId;
                });

                // eslint-disable-next-line
                if (index !== -1 && index !== 0) {
                    const tempId = currentIds[index];

                    currentIds.splice(index, 1);
                    currentIds.unshift(tempId);

                    Utils.setCookie(cardCookieName, JSON.stringify(currentIds));
                }
            } else {
                currentIds.unshift(currentCardId);

                Utils.setCookie(cardCookieName, JSON.stringify(currentIds.slice(0, 50)));
            }
        } else {
            const cardsIdList = [currentCardId];

            Utils.setCookie(cardCookieName, JSON.stringify(cardsIdList));
        }
    }
}

// Карта в контактах
const contactsMap = document.querySelector('.j-contacts-map') as HTMLElement;

if (contactsMap) {
    import(/* webpackChunkName: "contacts-map" */ '@/sections/contacts-map')
        .then(({default: initProjectsMap}: IDynamicImport) => {
            initProjectsMap(contactsMap);
        });
}

// Сервисы
const servicesWrapper = document.querySelector('.j-services-object') as HTMLElement;

if (servicesWrapper) {
    initServices(servicesWrapper);
}

// Карта в сервисах
const centerMap = document.querySelector('.j-center-map') as HTMLElement;

if (centerMap) {
    import(/* webpackChunkName: "center-map" */ '@/sections/poster')
        .then(({default: initCenterMap}: IDynamicImport) => {
            initCenterMap(centerMap);
        });
}

const detailsItems = [...document.querySelectorAll('.j-details')] as HTMLDetailsElement[];

if (detailsItems.length) {
    initDetails(detailsItems);
}

// Вакансии
const vacanciesWrapper = document.querySelector('.j-vacancies') as HTMLElement;

if (vacanciesWrapper) {
    initVacancies(vacanciesWrapper);
}

// Вопросы
const questionsBlocks = [...document.querySelectorAll('.j-questions')] as HTMLElement[];

questionsBlocks.forEach((block: HTMLElement) => {
    initQuestions(block);
});

// Тендеры
const tendersWrapper = document.querySelector('.j-tenders') as HTMLElement;

if (tendersWrapper) {
    initTenders(tendersWrapper);
}

// Подключение панели параметрического поиска
const searchPanelId = '#search-panel';
const searchPanelWrapper = document.querySelector(searchPanelId);

if (searchPanelWrapper) {
    searchPanelInit({
        id     : searchPanelId,
        wrapper: searchPanelWrapper
    });
}

// FileUploader
const fileInputs = [...document.querySelectorAll('.j-input-file-wrapper')] as HTMLElement[];

fileInputs.forEach((fileInput: HTMLElement) => {
    initFileUploader(fileInput);
});

// Cadastral
const cadastralItems = [...document.querySelectorAll('.j-cadastral')] as HTMLElement[];

cadastralItems.forEach((cadastral: HTMLElement) => {
    initCadastral(cadastral);
});
